/* Aurelia Intima theme: saved edit (local browser), menu, filters, Shopify variants and quantity. */
(function () {
  'use strict';
  var script = document.currentScript || document.querySelector('script[data-label-save]');
  var cfg = script ? script.dataset : {};
  var KEY = 'aurelia-intima-saved-v1';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- saved edit ---------- */
  function readSaved() {
    try {
      var p = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(p) ? p.filter(function (x, i) { return typeof x === 'string' && p.indexOf(x) === i; }) : [];
    } catch (e) { return []; }
  }
  var saved = readSaved();
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    window.clearTimeout(toast.id);
    toast.id = window.setTimeout(function () { t.hidden = true; }, 4200);
  }
  function writeSaved(next) {
    saved = next;
    try { localStorage.setItem(KEY, JSON.stringify(next)); }
    catch (e) { toast('Saved for this visit only. Your browser blocked storage, so your edit will not be kept after you leave this page.'); }
    renderSaved();
  }
  function renderSaved() {
    $$('[data-save]').forEach(function (b) {
      var on = saved.indexOf(b.dataset.handle) > -1, title = b.dataset.title;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? cfg.labelRemove : cfg.labelSave || '').replace('__T__', title));
      var t = $('[data-save-text]', b); if (t) t.textContent = on ? cfg.textSaved : cfg.textSave;
      var svg = $('svg', b); if (svg) svg.setAttribute('fill', on ? 'currentColor' : 'none');
    });
    $$('[data-saved-count]').forEach(function (n) { n.textContent = saved.length; });
    $$('[data-saved-link]').forEach(function (a) {
      if (saved.length) a.firstChild.textContent = 'View your saved edit (' + saved.length + ') ';
      else a.firstChild.textContent = (a.dataset.label || '') + ' ';
    });
    applyFilters();
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY || e.key === null) { saved = readSaved(); renderSaved(); } });

  /* ---------- collection filters (current page) ---------- */
  function params() { return new URLSearchParams(window.location.search); }
  function setParam(k, v) {
    var p = params(); if (v) p.set(k, v); else p.delete(k);
    var qs = p.toString();
    history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
  }
  function applyFilters() {
    var root = $('[data-collection-root]'); if (!root) return;
    var grid = $('[data-collection-grid]', root); if (!grid) return;
    var onlySaved = params().get('saved') === '1';
    var q = (($('[data-collection-q]', root) || {}).value || '').trim().toLowerCase();
    var btn = $('[data-saved-filter]', root);
    if (btn) { btn.classList.toggle('is-active', onlySaved); btn.setAttribute('aria-pressed', onlySaved ? 'true' : 'false'); }
    var cards = $$('[data-card]', grid), shown = 0;
    cards.forEach(function (c) {
      var ok = (!onlySaved || saved.indexOf(c.dataset.handle) > -1) && (!q || (c.dataset.search || '').indexOf(q) > -1);
      c.hidden = !ok; if (ok) shown++;
    });
    var active = onlySaved || q;
    var emptySaved = $('[data-empty-saved]', root), emptyFilter = $('[data-empty-filter]', root);
    var noSavedAtAll = onlySaved && !q && saved.length === 0;
    if (emptySaved) emptySaved.hidden = !(shown === 0 && noSavedAtAll);
    if (emptyFilter) emptyFilter.hidden = !(shown === 0 && !noSavedAtAll && active);
    var title = $('[data-collection-title]', root);
    if (title) title.textContent = onlySaved ? 'Your saved edit' : title.dataset.default;
    var count = $('[data-collection-count]', root);
    if (count) count.textContent = active ? shown + ' ' + (shown === 1 ? cfg.textPiecesOne.replace(/^\d+\s*/, '') : cfg.textPiecesOther.replace(/^\d+\s*/, '')) : count.dataset.default;
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var save = t.closest('[data-save]');
    if (save) {
      e.preventDefault();
      var h = save.dataset.handle, i = saved.indexOf(h);
      writeSaved(i > -1 ? saved.filter(function (x) { return x !== h; }) : saved.concat([h]));
      return;
    }
    var menu = t.closest('[data-menu-toggle]');
    if (menu) { setMenu(menu.getAttribute('aria-expanded') !== 'true'); return; }
    if (t.closest('.mobile-menu a')) setMenu(false);
    var sf = t.closest('[data-saved-filter]');
    if (sf) { setParam('saved', params().get('saved') === '1' ? null : '1'); applyFilters(); return; }
    if (t.closest('[data-reset-filters]')) {
      var qi = $('[data-collection-q]'); if (qi) qi.value = '';
      setParam('saved', null); applyFilters(); return;
    }
    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = $('input[type="number"]', step.parentNode);
      var min = Number(input.min || 0), max = input.max ? Number(input.max) : 99;
      input.value = Math.min(max, Math.max(min, (Number(input.value) || 0) + Number(step.dataset.qtyStep)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var th = t.closest('[data-thumb]');
    if (th) { showSlide(th.closest('[data-product-root]'), th.dataset.position); return; }
  });
  document.addEventListener('input', function (e) { if (e.target.matches('[data-collection-q]')) applyFilters(); });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort-select]')) e.target.form.submit();
    if (e.target.matches('[data-option-radio]')) syncVariant(e.target.closest('[data-product-root]'));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  function setMenu(open) {
    var b = $('[data-menu-toggle]'), m = $('#mobile-menu'); if (!b || !m) return;
    var was = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    b.setAttribute('aria-label', open ? cfg.menuClose : cfg.menuOpen);
    m.hidden = !open;
    $('[data-menu-icon-open]', b).hidden = open;
    $('[data-menu-icon-close]', b).hidden = !open;
    if (was && !open) b.focus();
  }

  /* ---------- product variants ---------- */
  function showSlide(root, pos) {
    if (!root) return;
    var any = false;
    $$('[data-slide]', root).forEach(function (s) { var on = s.dataset.position === String(pos); s.hidden = !on; any = any || on; });
    if (!any) return;
    $$('[data-thumb]', root).forEach(function (b) { var on = b.dataset.position === String(pos); b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  function syncVariant(root) {
    if (!root) return;
    var jsonEl = $('[data-variants-json]', root); if (!jsonEl) return;
    var variants; try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var fields = $$('[data-option-index]', root);
    var sel = fields.map(function (f) { var c = $('[data-option-radio]:checked', f); return c ? c.value : null; });
    var match = variants.filter(function (v) { return fields.length === 0 ? true : sel.every(function (s, i) { return s !== null && v.options[i] === s; }); })[0];
    if (!fields.length) match = variants[0];
    fields.forEach(function (f, fi) {
      var lab = $('[data-option-label]', f); if (lab) lab.textContent = sel[fi] ? ' - ' + sel[fi] : '';
      $$('[data-option-radio]', f).forEach(function (r) {
        var cand = variants.filter(function (v) { return sel.every(function (s, i) { return i === fi ? v.options[i] === r.value : v.options[i] === s; }); })[0];
        var un = !cand || !cand.available;
        var label = r.nextElementSibling;
        label.classList.toggle('unavailable', un);
        var hint = $('[data-unavailable-text]', label); if (hint) hint.hidden = !un;
      });
    });
    var idInput = $('[data-variant-id]', root);
    if (idInput) { idInput.value = match ? String(match.id) : ''; idInput.disabled = !match || !match.available; }
    $$('[data-price]', root).forEach(function (p) { if (match) p.textContent = match.price; });
    var ok = !!(match && match.available);
    var main = $('[data-add-button]', root), sticky = $('[data-sticky-add]', root);
    [main, sticky].forEach(function (b) {
      if (!b) return;
      b.disabled = !ok;
      b.textContent = !match ? b.dataset.textChoose : ok ? b.dataset.textAdd : b.dataset.textUnavailable;
    });
    var st = $('[data-status]', root);
    if (st) { st.hidden = ok; st.textContent = !match ? st.dataset.textNone : ok ? '' : st.dataset.textUnavailable; }
    if (match) {
      if (match.mediaPosition) showSlide(root, match.mediaPosition);
      if (window.history.replaceState) {
        var variantUrl = new URL(window.location.href);
        variantUrl.searchParams.set('variant', match.id);
        window.history.replaceState(null, '', variantUrl.pathname + variantUrl.search + variantUrl.hash);
      }
    }
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    var els = $$('.rv:not(.in)');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window) || document.documentElement.classList.contains('is-editor')) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    renderSaved(); initReveal();
    $$('[data-product-root]').forEach(syncVariant);
  }
  document.addEventListener('shopify:section:load', function () { init(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
